// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__lV","cls2":"ResearchInterestTags-cls2_f6Q ResearchInterestTags-cls1__lV","hasError":"ResearchInterestTags-hasError_ldN"};